module.exports = __webpack_public_path__ + "media/fuzion-flooring-poster.8555ea09.mp4";